/**
 * Tutorial guidato dell'invio di notifiche push.
 *
 * Nessun preparativo: il modulo e' tutto a schermo, e il tutorial non tocca niente.
 * La cronologia sta in una finestra che si apre dal pulsante in alto: il passo
 * illumina il pulsante e racconta cosa c'e' dentro, senza aprirla - una finestra
 * aperta dal tutorial coprirebbe il modulo e andrebbe poi richiusa.
 */
const SCOPE = '[data-tour-scope="push-notifications"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createPushNotificationsTourSteps() {
	return [
		{
			body: "Da qui parte una notifica push, quella che compare sul telefono o sul browser anche quando il sito e' chiuso. Arriva solo a chi l'ha permesso dal proprio dispositivo: non e' una mail, non si puo' mandare a un indirizzo, e chi non ha dato il consenso non la ricevera' mai.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Le notifiche push',
		},
		{
			body: "Titolo e Messaggio sono gli unici campi obbligatori, e hanno un tetto stretto - sessantacinque e duecentoquaranta caratteri - perche' sullo schermo del telefono il resto verrebbe tagliato. Il contatore accanto al campo dice quanto manca.",
			key: 'content',
			placement: 'right',
			target: at('content'),
			title: 'Il testo della notifica',
		},
		{
			body: "Due campi facoltativi ma utili: l'indirizzo di un'immagine, che compare dentro la notifica, e il Link, cioe' dove finisce chi la tocca. Senza link la notifica si limita ad avvisare; con il link porta il cliente dritto al prodotto o alla pagina che stai promuovendo.",
			key: 'media',
			placement: 'right',
			target: at('media'),
			title: "L'immagine e il link",
		},
		{
			body: "A chi mandarla: a tutti quelli che hanno attivato le notifiche, oppure a un gruppo solo. I gruppi sono quattro e li calcola il sistema: chi ha ordinato negli ultimi trenta giorni, chi ha piu' di cinque ordini, chi non ordina da novanta giorni e gli iscritti alla newsletter.",
			key: 'target',
			placement: 'right',
			target: at('target'),
			title: 'I destinatari',
		},
		{
			body: 'Su quali dispositivi mandarla: ogni riquadro si accende e si spegne con un clic, e ne serve almeno uno. Di solito si lasciano tutti accesi; toglierne una ha senso quando il messaggio riguarda una sola app.',
			key: 'platforms',
			placement: 'right',
			target: at('platforms'),
			title: 'Le piattaforme',
		},
		{
			body: "L'anteprima si aggiorna mentre scrivi e mostra la notifica come la vedra' il cliente. E' il posto dove accorgersi che il titolo e' troppo lungo o che il messaggio, tagliato, non dice piu' niente.",
			key: 'preview',
			placement: 'left',
			target: at('preview'),
			title: "L'anteprima",
		},
		{
			body: "Invia subito parte appena premi il pulsante. Programma chiede giorno e ora e mette la notifica in coda: il server la controlla ogni cinque minuti, quindi parte entro cinque minuti dall'orario scelto, non al secondo esatto.",
			key: 'schedule',
			placement: 'left',
			target: at('schedule'),
			title: "Subito o piu' tardi",
		},
		{
			body: "Il pulsante, sempre in fondo alla pagina, cambia nome a seconda di cosa hai scelto: Invia notifica o Programma invio. Resta spento finche' manca qualcosa, e il Riepilogo accanto all'anteprima dice cosa. Una volta partita non si richiama piu' - a differenza di una mail non c'e' una bozza da correggere - quindi vale la pena rileggere l'anteprima prima di premerlo. Resetta accanto svuota il modulo e ricomincia.",
			key: 'send',
			placement: 'top',
			target: at('send'),
			title: 'Inviare',
		},
		{
			body: "Cronologia invii apre lo storico: data, stato, piattaforme e soprattutto quante notifiche sono state consegnate e quante sono fallite. Il numero dei falliti e' normale che non sia zero - sono dispositivi che hanno disinstallato l'app o revocato il permesso.",
			key: 'history',
			placement: 'left',
			target: at('history'),
			title: 'Lo storico degli invii',
		},
	];
}
